export default {
  data() {
    return {
      screenWidth: 0,
      bLoading: false,
      subcatalog: "",
      warehouse: "",
      numberBoxes: "",
      unitPrice: "",
      unitMeasure: "",
      productAvailableTime: "",
      lotNumber: "",
      transportationTemp: "",
      storageTemp: "",
      itemsSubcategories: [],
      itemsUnitMeasure: [],
      texts: "",
      articleNameEn: "",
      articleNameSp: "",
      articleDescriptionEn: "",
      articleDescriptionSp: "",
      menu: false,
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  destroyed() {
    this.close()
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth >= 960) {
        this.screenWidth = 40;
      } else {
        this.screenWidth = 100;
      }
    },
    close() {
      this.$store.commit("setDialogAddArticle", false);
      this.subcatalog = "";
      this.warehouse = "";
      this.numberBoxes = "";
      this.unitPrice = "";
      this.unitMeasure = "";
      this.productAvailableTime = "";
      this.lotNumber = "";
      this.transportationTemp = "";
      this.storageTemp = "";
      this.itemsSubcategories = [];
      this.itemsUnitMeasure = [];
      this.articleNameEn = "";
      this.articleNameSp = "";
      this.articleDescriptionEn = "";
      this.articleDescriptionSp = "";
    },
    addArticle() {
      this.bLoading = true;

      const params = {
        sSubcategoryId: this.subcatalog,
        sVendorWarehouseId: null,
        dMinAmountAllowed: this.numberBoxes,
        dUnitPrice: this.unitPrice,
        sMeasurementUnitId: this.unitMeasure,
        tProductAvailableTime: this.productAvailableTime,
        sLotId: this.lotNumber,
        dTransportationTemperature: this.transportationTemp,
        dStorageTemperature: this.storageTemp,
        aTranslations: [
          {
            sLang: "sp",
            sName: this.articleNameSp,
            sDescription: this.articleDescriptionSp,
          },
          {
            sLang: "en",
            sName: this.articleNameEn,
            sDescription: this.articleDescriptionEn,
          },
        ],
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`,
        },
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/products`, params, config)
        .then((response) => {
          this.bLoading = false;

          this.close();
          this.mixSuccess(response.data.message);
          this.$store.commit("refresher", true);
        })
        .catch((error) => {
          this.bLoading = false;
                    this.mixError(error.response.data.message,error.response.status);
        });
    },
    subcategory() {
      //post credentials and get access token from laravel backend
      DB.get(`${URI}/api/v1/${this.selectLanguage}/subcategories`, {
        headers: {
          Authorization: "Bearer " + this.$store.state.sToken,
        },
        params: {
          iPageNumber: 1,
        },
      })
        .then((response) => {
          this.itemsSubcategories = response.data.results;
        })
        .catch((error) => {
                    this.mixError(error.response.data.message,error.response.status);
        });
    },
    measureUnits() {
      //post credentials and get access token from laravel backend
      DB.get(`${URI}/api/v1/${this.selectLanguage}/measurement_units`, {
        headers: {
          Authorization: "Bearer " + this.$store.state.sToken,
        },
        params: {
          iPageNumber: 1,
        },
      })
        .then((response) => {
          this.itemsUnitMeasure = response.data.results;
        })
        .catch((error) => {
                    this.mixError(error.response.data.message,error.response.status);
        });
    },
  },
  computed: {
    dialogAddArticle() {
      return this.$store.state.dialogAddArticle;
    },
    selectLanguage() {
      return this.$store.state.language;
    },
    validateForm() {
      return (
        this.subcatalog !== "" &&
        this.warehouse !== "" &&
        this.numberBoxes !== "" &&
        this.unitPrice !== "" &&
        this.unitMeasure !== "" &&
        this.productAvailableTime !== "" &&
        this.productAvailableTime !== null &&
        this.lotNumber !== "" &&
        this.transportationTemp !== "" &&
        this.storageTemp !== "" &&
        this.articleNameEn !== "" &&
        this.articleNameSp !== "" &&
        this.articleDescriptionEn !== "" &&
        this.articleDescriptionSp !== ""
      );
    },
  },
  watch: {
    dialogAddArticle: function () {
      if (this.dialogAddArticle) {
        this.texts = FILE.articleTexts[this.selectLanguage];
        this.subcategory();
        this.measureUnits();
      }
    },
    selectLanguage() {
      if (this.selectLanguage) {
        this.texts = FILE.articleTexts[this.selectLanguage];
      }
    },
  },
};